import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=59f4ff46&scoped=true"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=59f4ff46&prod&scoped=true&lang=css&external"
import style1 from "./Beneficiaries.vue?vue&type=style&index=1&id=59f4ff46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4ff46",
  null
  
)

export default component.exports